function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m333.5 835.5v-80c-0.01-5.57-0.22-9.84-2.72-15-7.8-16.09-29.88-19.94-43.19-8.52-7.91 6.79-10.07 14.54-10.09 24.52v77h-221v-388h221v133c0.01 9.08 1.46 17.09 8.18 23.82 12.67 12.66 34.44 10.54 44.02-4.82 3.11-5 3.77-10.27 3.8-16v-136h301c15.55-0.02 30.77-8.9 31-26 0.25-19.55-11.96-29.97-31-30h-578v-332h888v332h-133c-17.12 0.03-30.22 8.66-30.96 27-0.74 18.3 12.56 28.97 29.96 29h134v388h-326c-7.9 0.01-15.64 1.08-22 6.27-15.3 12.5-15.18 35.01 2 45.78 6.49 4.06 13.52 4.94 21 4.95h346c19.5-0.03 34.97-7.15 35-29v-831c-0.03-19.08-12.32-29.78-31-30h-935c-19.78 0.03-33.97 8.6-34 30v831c0.01 3.76-0.12 6.34 1.1 10 6.41 19.08 26.34 19 42.9 19h327c10.44 0.02 12.04 3.43 20 9.8 41.202 32.988 85.102 68.088 121 96.6 18.81 12.56 45.3-2.79 43.91-25.4-0.8-12.96-9.49-19.85-18.91-27.4-36.594-29.33-73.313-58.506-110-87.72-8.07-6.21-20.46-17.54-30-20.25-2.6-0.73-5.32-0.63-8-0.63z",
  stroke: "none"
});

var SvgType = function SvgType(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    fill: "#000",
    width: "264.85mm",
    height: "265.09mm",
    viewBox: "0 0 1001 1001.9073",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgType, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/type.25469966.svg";
export { ForwardRef as ReactComponent };